import { createSlice } from '@reduxjs/toolkit';
import { isCP } from '@utils/app-utils';

const initialState = {
  userInfo: {},
  authorize: !!isCP(),
  redirect: true,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo(state, action) {
      const {
        name = '',
        email = '',
        image = '',
        authorize = false,
        permission_map = {},
        roles = [],
        id = null,
      } = action.payload;
      state.userInfo = { name, email, image, permission_map, roles, id };
      state.authorize = authorize;
    },
    setAuthorized(state, action) {
      state.authorize = action.payload;
    },
    clearUserInfo(state, action) {
      state.authorize = false;
      state.userInfo = {};
      if (action?.payload?.logout) {
        state.redirect = false;
      }
    },
  },
});

export const { setUserInfo, clearUserInfo, setAuthorized } = userSlice.actions;
export default userSlice.reducer;
